import {DEFAULT_THEME, type DefaultMantineColor} from '@mantine/core'

/** `css` for DOM styles, `hex` for Google Maps polylines. */
export type RunMapColor = {css: string; hex: string}

function buildRunMapColorFromMantine(color: DefaultMantineColor, shade = 6): RunMapColor {
    return {
        css: `var(--mantine-color-${color}-${shade})`,
        hex: DEFAULT_THEME.colors[color]?.[shade] ?? DEFAULT_THEME.black,
    }
}

const YARD_COLORS = (['blue', 'orange', 'grape', 'teal'] as const).map((color) =>
    buildRunMapColorFromMantine(color),
)

const NO_YARD_COLOR = buildRunMapColorFromMantine('gray')

export const LATE_LEG_COLOR = buildRunMapColorFromMantine('red')
export const ROUTE_COLOR: RunMapColor = {
    css: 'var(--mantine-color-text)',
    hex: buildRunMapColorFromMantine('gray', 8).hex,
}

export function yardColor(index: number): RunMapColor {
    return index < 0 ? NO_YARD_COLOR : (YARD_COLORS[index % YARD_COLORS.length] ?? NO_YARD_COLOR)
}
